import {useTranslation} from "@Translation/hooks/useTranslation";
import FilterButton from "@Generic/buttons/FilterButton";
import React from "react";
import usePopularFilters from "@SearchResults/features/sidebar/features/popularFilters/hooks/usePopularFilters";
import useDispatchFilterEvents from "@SearchResults/features/sidebar/hooks/useDispatchFilterEvent";
import IconLightning from "@Icons/searchRes/filters/IconLightning";
import {Colors} from "@Styles/Colors.style";

function InstantConfirmationFilter() {
    const label = useTranslation("search_results.filter_by.popular_filters.filters.instant_confirmation")
    const {isActive, setActive} = usePopularFilters("instantConfirmation")

    const handleOnBlur = useDispatchFilterEvents('instantConfirmationFilter', isActive.toString());

    return (
        <FilterButton
            label={label}
            active={isActive}
            icon={(
                <IconLightning
                    width="20"
                    height="20"
                    stroke={isActive ? Colors.primaryColor : Colors.neutralDarkestColor}
                />
            )}
            onClick={setActive}
            onBlur={handleOnBlur}
        />
    );
}

export default InstantConfirmationFilter;